import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import { store } from './store'
import AlertCmp from './components/components/Alert.vue'
import GuestDialog from './components/Guests/GuestDialog.vue'
import DateFilter from './filters/date'
import UpperCaseFilter from './filters/upperCase'
import CapitalizeFilter from './filters/capitalize'
import Polyglot from 'vue-polyglot'
import VueLocalStorage from 'vue-ls'
import colors from 'vuetify/es5/util/colors'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)
Vue.use(Polyglot, {
  defaultLanguage: 'cs',
  languagesAvailable: ['cs']
})
Vue.locales({
  'cs': require('../static/i18n/cs.json')
})
// var utils = require('./utils')
// utils.setI18N(i18n)

Vue.use(VueLocalStorage)
Vue.use(Vuetify, {
  theme: {
    primary: '#35495d',
    accent: '#009ee2',
    secondary: '#34495e',
    info: colors.blue.lighten1,
    warning: colors.amber.darken2,
    error: colors.red.accent4,
    success: colors.green.lighten2
  }
})
Vue.filter('date', DateFilter)
Vue.filter('upper', UpperCaseFilter)
Vue.filter('capitalize', CapitalizeFilter)

Vue.directive('title', {
  inserted: (el, binding) => { document.title = binding.value },
  update: (el, binding) => { document.title = binding.value }
})

Vue.config.productionTip = false

if (process.env.NODE_ENV !== 'development') {
  global.__static = require('path').join(__dirname, '/static').replace(/\\/g, '\\\\')
}

Vue.component('app-alert', AlertCmp)
Vue.component('guest-dialog', GuestDialog)

/* eslint-disable import/first */
// utils.js musi byt nahrany az po vytvoreni i18n !!!
import { HTTP } from './utils'

const token = localStorage.getItem('token')
HTTP.defaults.headers.common['Authorization'] = token

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,

  created () {
    console.log('ROUTE', this.$route)
    let lang = this.$ls.get('active_language', '')
    if (lang.length === 0 && window.location.host === 'app.whoarrived.com') {
      lang = 'en'
    } else {
      lang = 'cs'
    }
    this.$polyglot.getLocale({ baseURL: 'static/i18n', lang })

    const hotelName = localStorage.getItem('hotel_name')
    this.$store.commit('setUser', { uid: token, hotel: hotelName })

    let lastUrl = this.$ls.get('last_url', '/')
    // console.log('lastUrl: ' + lastUrl)
    if (this.$route.query.page) {
      lastUrl = '/' + this.$route.query.page
    } else if (token && token !== null && token.length && lastUrl === '/') {
      lastUrl = '/search'
    }
    this.$router.push(lastUrl)
    this.$router.beforeEach((to, from, next) => {
      // console.log('beforeEach: ' + to.path + '; token: ' + token)
      // console.log('to: ' + JSON.stringify(to))
      const token = localStorage.getItem('token')
      if (to.path === '/' && token !== null && token.length > 0) {
        // console.log('beforeEach: go to search ...')
        next('/search')
      } else {
        next()
      }
    })

    this.$router.afterEach((to, from) => {
      // console.log('afterEach: ' + to.path)
      this.$ls.set('last_url', to.path)
    })

    HTTP.get('profile')
      .then(response => {
        const data = response.data
        this.$store.commit('setUser', data)
      })
      .catch(error => {
        console.log('Profile ERROR: ' + error)
      })
  }
})



// WEBPACK FOOTER //
// ./src/main.js